import { useSelector } from "react-redux";
import { Truck } from "lucide-react";
import { TRANSIT_COLUMNS } from "../../utils/table.config";
import ArrowSorting from "../../../../components/common/ArrowSorting";
import { formatDate } from "../../../../functions/dateTime/formatDate";

export const TransitTable = () => {
  const data = useSelector((state) => state.data.data);
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden mt-2">
      <div className="h-[calc(100vh-15em)] max-lg:h-[calc(100vh-14em)] max-md:h-[calc(100vh-13em)] overflow-auto">
        <table className="w-full border border-b-0">
          {/* Header */}
          <thead className="bg-[#f4f6fc] text-blue-1 uppercase text-[14px] max-lg:text-[11px] sticky top-0 2xs:max-md:top-0 z-99">
            <tr>
              {TRANSIT_COLUMNS.map((c) => (
                <th key={c.title} className="text-left px-4 py-3">
                  <span className="flex items-center">
                    {c.title}{" "}
                    {c.sortArrow && data.length > 1 && (
                      <ArrowSorting
                        sortBy={c.sortBy}
                        address={c.address}
                        arrowColor="#3a4faa"
                      />
                    )}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          {/* Body */}
          <tbody className="text-[14px] max-lg:text-xs">
            {data.length > 0 ? (
              data.map((c) => (
                <tr
                  key={c.id}
                  className="border-t hover:bg-gray-50 text-gray-800 [&_td]:p-3"
                >
                  <td>
                    <p className="text-primary font-figtreeMedium bg-[#f0f2f7] px-2 py-[3px] rounded-xl inline-block">
                      {c.cylinder_no}
                    </p>
                  </td>
                  <td>{formatDate(c.dispatched_date)}</td>
                  <td className="font-figtreeMedium">
                    {c.dispatched_from_station}
                  </td>
                  <td>{c.dispatched_by}</td>
                  <td>
                    <p className="inline-flex px-2 bg-amber-50 border-1 border-amber-500 rounded-md items-center gap-1">
                      <Truck className="text-amber-700" size={15} />
                      {c.vehicle_no}
                    </p>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={TRANSIT_COLUMNS.length}
                  className="text-center py-6 text-gray-500"
                >
                  No match the current filter.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
